import * as React from "react";
import { DefaultButton } from "office-ui-fabric-react/lib";
import { RouteComponentProps, Route } from "react-router";
import { RootState } from "~/state";
import { getFolderContent, getMedia, getTemplateById, getLanguages } from "~/state/action";
import { deleteMedia, loadMedia, updateMedia } from "~/state/media/action";
import { isNullOrUndefined } from "util";
import { connect } from "react-redux";
import { LibraryStyle, FolderInfo, ContentStyle } from "./style";
import Media from "./Media";
import ListMediaFiles from "./ListMediaFiles";
export interface Props extends RouteComponentProps<{parentId?: string}>
{
    libraryName: string;
   
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    const parentId = ownProps.match.params.parentId;
    let libraryName ="Root";
    if (parentId && parentId !== "new")
    {
        const media = getMedia(state, parentId);
        if (media)
        {
            libraryName = media.data.name.value;
        }
    }
    return {
        files: getFolderContent(state, parentId),
        libraryName,
        languages: getLanguages(state),
        templates: {
            file: getTemplateById(state, "file"),
            image: getTemplateById(state, "image"),
            youtube: getTemplateById(state, "youtube")
        }
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    deleteMedia: (id: string) => dispatch(deleteMedia(id)),
    loadMedia: (id: string) => dispatch(loadMedia(id)),
    updateMedia: (id:string , update: { [key: string]: any} ) => dispatch(updateMedia(id, update))
});
export interface ReactFilesComponent extends React.Component<any, any>
{
    removeFiles: () => void;
}

class Library extends React.Component<Props & StateProps>
{
    public componentWillMount() 
    {
        const parentId = this.props.match.params.parentId;
        if (parentId && parentId !== "new")
        {
            this.props.loadMedia(parentId);
        }
    }

    public componentWillReceiveProps(props: Props)
    {
        const parentId = props.match.params.parentId;
        if (parentId  && parentId !== "new" && parentId !== this.props.match.params.parentId)
        {
            this.props.loadMedia(parentId);
        }
    }

    onCreateFolderClick = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}${parentId ? "/" :""}new/folder/`);
    }

    onUploadClick = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}${parentId ? "/" :""}upload/`);
    }

    onLinkClick = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}${parentId ? "/" :""}youtube/`);
    }

    onItemClick = (type: string, id: string) => () => 
    {
        const path = type === "folder" ? `/media/${id}` : `/media/${this.props.match.params.parentId}/item/${id}`;
        this.props.history.push(path);

    }

    onDeleteMediaItemClick = (id: string) => () =>
    {
        if (confirm("Are you sure you want to delete this item? This file might be in use"))
        {
            this.props.deleteMedia(id);
            this.props.history.goBack();
        }
    }

    renderItemView = (props: RouteComponentProps<{ parentId?: string, id: string }>) =>
    {
        const id = props.match.params.id;
        const item = this.props.files.find(x => x.id === id);
        return  <Media {...props} 
            templates={this.props.templates} 
            item={item}
            updateMedia={(value: { [key: string]: any}) => this.props.updateMedia(id, value)}
            languages={this.props.languages}
            deleteItem={this.onDeleteMediaItemClick(id)}
            />;
    }
    


    render()
    {
        const parentId = this.props.match.params.parentId;
        const dropdownMenu =  [{
            key: "newFolder",
            text: "New Folder",
            iconProps: {
                iconName: "FolderHorizontal"
            },
            onclick: this.onCreateFolderClick,
            onMouseDown: this.onCreateFolderClick,
        }];
        if (!isNullOrUndefined(parentId))
        {
            dropdownMenu.push({
                key: "media",
                text: `Upload Media`,
                iconProps: {
                    iconName: "BulkUpload"
                },
                onclick: this.onUploadClick,
                onMouseDown: this.onUploadClick,
            });
            dropdownMenu.push({
                key: "media",
                text: `Upload Youtube`,
                iconProps: {
                    iconName: "MSNVideos"
                },
                onclick: this.onLinkClick,
                onMouseDown: this.onLinkClick,
            });
            dropdownMenu.push({
                key: "media",
                text: `Delete folder`,
                iconProps: {
                    iconName: "Delete"
                },
                onclick: () => this.props.deleteMedia(parentId),
                onMouseDown: () => this.props.deleteMedia(parentId),
            });
          
        }
        return (
            <LibraryStyle>
              
                <FolderInfo>
                    <DefaultButton text={`${this.props.libraryName} (${this.props.files.length})`}  menuProps={{ items: dropdownMenu }} />
                </FolderInfo>                
                <ContentStyle>
                    <ListMediaFiles
                       files={this.props.files}
                       onItemClick={this.onItemClick}
                    />
                  <Route path={`${this.props.match.path}/item/:id`} component={this.renderItemView}  />
                </ContentStyle>
                
            </LibraryStyle>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Library);




// WEBPACK FOOTER //
// ./src/components/media/Library.tsx